module.exports = __webpack_public_path__ + "img/960x540 Site.55d57d6d.png";